module.exports = __webpack_public_path__ + "img/biaoti1.f5cbfb6f.png";